import React from "react";
import { ErrorTemplate } from "components/ErrorTemplate";
import { ClientError as ClientErrorData } from "helpers/Consts";
import { useTitleChange } from "hooks/useTitleChange";
export const ClientError = () => {
  useTitleChange();
  return <ErrorTemplate {...ClientErrorData} />;
};
